import React, { useState, useEffect } from "react";
import PageTop from "./Components/PageTop";
import { themsField, Colors } from "@/config/config";
import { ConfigProvider } from "antd";
import { AppProvider, useAppContext } from "./AppContext";

const App = () => {
  const [curTheme, setCurTheme] = useState<any>("light");
  useEffect(() => {
    setCurTheme(
      localStorage.getItem(themsField)
        ? localStorage.getItem(themsField)
        : "light"
    );
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    Object.entries(Colors).forEach(([key, value]) => {
      root.style.setProperty(`--color-${key.toLowerCase()}`, value);
    });
  }, []);

  return (
    <div className={curTheme}>
      <ConfigProvider
        theme={{
          token: {
            colorSuccess: Colors.SECONDARY,
            colorLink: Colors.SECONDARY,
            wireframe: true,
            colorPrimaryBg: Colors.NEUTRAL_5,
            colorPrimary: Colors.PRIMARY,
            colorInfo: Colors.PRIMARY,
          },
          components: {
            Button: {
              colorPrimary: Colors.TEXT,
            },
            Tabs: {
              cardBg: Colors.PRIMARY,
              itemColor: "#FFF",
            },
          },
        }}
      >
        <PageTop setCurTheme={(t: any) => setCurTheme(t)} />
      </ConfigProvider>
    </div>
  );
};
const RootComponent = () => {
  return (
    <AppProvider>
      <App />
    </AppProvider>
  );
};
export default RootComponent;
